import React, { useState, useRef, useEffect } from "react";
import { SendIcon } from "lucide-react";

const FloatingChatInput = ({ onSendMessage, disabled = false }) => {
  const [message, setMessage] = useState("");
  const textareaRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim() || disabled) return;
    onSendMessage(message.trim());
    setMessage("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${Math.min(
        textareaRef.current.scrollHeight,
        80
      )}px`;
    }
  }, [message]);

  return (
    <form
      onSubmit={handleSubmit}
      className="border-t border-skin-base bg-skin-fill p-3"
    >
      <div className="flex items-end space-x-2">
        <textarea
          ref={textareaRef}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type your message..."
          disabled={disabled}
          className="flex-1 resize-none rounded-xl py-2.5 px-3 pr-10 max-h-20 text-sm text-skin-base bg-skin-fill-secondary placeholder:text-skin-muted focus:outline-none focus:ring-2 focus:ring-skin-base scrollbar-thin"
          rows={1}
          autoFocus
        />
        <button
          type="submit"
          disabled={!message.trim() || disabled}
          className={`rounded-full p-2.5 focus:outline-none transition-colors flex-shrink-0 ${
            !message.trim() || disabled
              ? "bg-[var(--color-button-disabled)] text-[var(--color-button-disabled-text)] cursor-not-allowed"
              : "bg-skin-button-base hover:bg-skin-button-hover text-white"
          }`}
        >
          <SendIcon size={16} />
        </button>
      </div>
    </form>
  );
};

export default FloatingChatInput;
